import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconShutDown$1 = /*@__PURE__*/ proxyCustomElement(class WppIconShutDown extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-shut-down", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { d: "M10.75 2.5C10.75 2.08579 10.4142 1.75 10 1.75C9.58579 1.75 9.25 2.08579 9.25 2.5V8.5C9.25 8.91421 9.58579 9.25 10 9.25C10.4142 9.25 10.75 8.91421 10.75 8.5V2.5ZM13.7432 4.00091C13.3843 3.79418 12.9257 3.91757 12.719 4.2765C12.5122 4.63544 12.6356 5.094 12.9946 5.30073C14.1393 5.96007 15.0345 6.9788 15.5412 8.19885C16.0478 9.4189 16.1377 10.7721 15.7968 12.0484C15.4559 13.3247 14.7032 14.4528 13.6557 15.2578C12.6081 16.0627 11.3242 16.4993 10.0031 16.5C8.68207 16.5007 7.3977 16.0654 6.3493 15.2616C5.30091 14.4578 4.54711 13.3304 4.20485 12.0545C3.8626 10.7785 3.95103 9.42523 4.45643 8.20465C4.96182 6.98407 5.85592 5.96441 7 5.30387C7.35872 5.09676 7.48163 4.63807 7.27452 4.27935C7.06742 3.92063 6.60872 3.79773 6.25 4.00483C4.8199 4.8305 3.70227 6.10508 3.07053 7.6308C2.43879 9.15653 2.32825 10.8481 2.75607 12.4431C3.18388 14.038 4.12613 15.4472 5.43663 16.452C6.74712 17.4567 8.35259 18.0009 10.0039 18C11.6553 17.9992 13.2602 17.4533 14.5696 16.4472C15.879 15.4411 16.8198 14.0309 17.246 12.4355C17.6721 10.8401 17.5598 9.14861 16.9265 7.62355C16.2931 6.09849 15.1742 4.82508 13.7432 4.00091Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-shut-down-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-shut-down", "wpp-icon-shut-down-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-shut-down-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-shut-down-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconShutDown$1);
      }
      break;
  } });
}

const WppIconShutDown = WppIconShutDown$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconShutDown, defineCustomElement };
